import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let questionSettingTemplate = class questionSettingTemplate extends Vue {};
__decorate([Prop({
  type: String,
  default() {
    return {};
  }
})], questionSettingTemplate.prototype, "typeText", void 0);
questionSettingTemplate = __decorate([Component({
  name: "questionSettingTemplate",
  filters: {}
})], questionSettingTemplate);
export default questionSettingTemplate;